import { OrganisationSettingsHttpService } from 'shared/util-common';

import { Organisation, OrganisationDto } from '@treetop/shared/model';

export const mapOrganisationDtoToOrganisation = (dto: OrganisationDto): Organisation => {
  if (!dto) {
    return undefined;
  }

  return {
    id: dto.id,
    code: dto.code,
    displayName: dto.displayName,
    organisationSettings: OrganisationSettingsHttpService.mapOrganisationSettingsDtoToOrganisationSettings(dto.organisationSettings),
    isHubOrganisation: dto.isHubOrganisation,
    parentId: dto.parentId,
    coreOrganizationId: dto.coreOrganizationId,
  };
};

export const mapOrganisationToDto = (organisation: Organisation): OrganisationDto => {
  if (!organisation) {
    return undefined;
  }

  return {
    id: organisation.id,
    code: organisation.code,
    displayName: organisation.displayName,
    organisationSettings: OrganisationSettingsHttpService.mapOrganisationSettingsToOrganisationSettingsDto(
      organisation.organisationSettings,
    ),
    isHubOrganisation: organisation.isHubOrganisation,
    parentId: organisation.parentId,
  };
};
